export default __webpack_public_path__ + "static/media/mirror2.9ad5be55.png";